import { render } from "./CalculationOverlay.vue?vue&type=template&id=10732152&ts=true"
import script from "./CalculationOverlay.vue?vue&type=script&lang=ts"
export * from "./CalculationOverlay.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__